import { API_URL } from '../../../../utils/config';

export const CREATE_ACCOUNT_URL = `${API_URL}/account`;
export const UPLOAD_INSTALLATION_IMAGES_URL = `${API_URL}/installationUploads`;
export const AVAILABLE_INSTALLATION_TIMES_URL = `${API_URL}/availableInstallationTime`;
